export default __webpack_public_path__ + "static/media/ourmission.50cfd8f0.jpg";